import {useQueries} from "@tanstack/react-query";
import GarrisonDamageService from "../../../../../services/reports/garrison-damage-service.js";

const UseFetchOptions = () => {

    const queries = useQueries({
        queries: [
            {
                queryKey: ['vehicles'],
                queryFn: () => GarrisonDamageService.getAllVehicles(),
                initialData: []
            }
        ]
    });

    return {
        vehicleOptions: queries[0].data
    };
};

export default UseFetchOptions;